import { helper } from '@ember/component/helper';

export default helper(function percent([count, total]) {
  if (!total || total === 0) return '0';
  let pct = Math.round((count / total) * 100);
  if (pct === 0 && count > 0) return '<1';
  return String(pct);
});
